import { FC, useState } from "react";
import {
  HomeHero720Webp,
  HomeHero1200Webp,
  HomeHero2468Webp,
  HomeHero720Png,
  HomeHero1200Png,
  HomeHero2468Png,
} from "assets/images";
import {
  TestimonialSection,
  HeroSection,
  FaqSection,
  PartnerSection,
  FeatureSection,
  PersonasSection,
  OngoingProjectSection,
} from "components";
import { HomeModal } from "components/navbar/HomeModal";

export const HomePage: FC = () => {
  const [isHomeModalOpen, setIsHomeModalOpen] = useState(false);
  return (
    <>
      <HeroSection
        title="Powering Smart Capital Deployment to Build Africa’s 50 Million Housing Deficit"
        subtitle="Deploy capital to build projects, with tools that lower risk, increase efficiency, enhance oversight, and ensure stakeholder accountability."
        imageSrc={HomeHero1200Png}
        imageWebpSrcSet={[
          `${HomeHero720Webp} 720w`,
          `${HomeHero1200Webp} 1200w`,
          `${HomeHero2468Webp} 2468w`,
        ].join(", ")}
        imageFallbackSrcSet={[
          `${HomeHero720Png} 720w`,
          `${HomeHero1200Png} 1200w`,
          `${HomeHero2468Png} 2468w`,
        ].join(", ")}
        imageWidth={2468}
        imageHeight={1880}
        showPrimaryAction={false}
        secondaryAction={{
          label: "Learn More",
          onClick: () => setIsHomeModalOpen(true),
        }}
      />
      <PartnerSection />
      <PersonasSection />
      <FeatureSection />
      <OngoingProjectSection />
      <TestimonialSection />
      <FaqSection />
      {isHomeModalOpen && (
        <HomeModal onClose={() => setIsHomeModalOpen(false)} />
      )}
    </>
  );
};
